export default function Pricing() {
  const included = [
    'Full playtest report',
    'Fun Score breakdown',
    'Target demo insights',
    'Honest feedback',
    'Mac-specific performance notes',
    'The "Tell-a-Friend" verdict',
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-16 md:py-32 px-4 md:px-8 bg-[#242428] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 50px, #00f0ff 50px, #00f0ff 51px), repeating-linear-gradient(90deg, transparent, transparent 50px, #00f0ff 50px, #00f0ff 51px)',
      }}></div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-6xl font-bold text-white mb-4 px-4">Support a Young Entrepreneur</h2>
        </div>

        <div className="max-w-lg mx-auto bg-[#1a1a1d] rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-[0_0_40px_rgba(0,240,255,0.3)] border-2 border-[#00f0ff]/20">
          <div className="text-center mb-6 md:mb-8">
            <div className="text-6xl md:text-8xl font-black text-[#39ff14] mb-2">$15</div>
            <p className="text-[#b8b8b8] text-base md:text-lg">Per detailed review</p>
          </div>

          <div className="space-y-3 md:space-y-4 mb-8 md:mb-10">
            {included.map((item, index) => (
              <div key={index} className="flex items-center gap-3 md:gap-4">
                <div className="w-5 h-5 md:w-6 md:h-6 bg-[#39ff14] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xs md:text-sm text-[#0d0d0f]"></i>
                </div>
                <p className="text-white text-sm md:text-lg">{item}</p>
              </div>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="w-full py-4 md:py-5 bg-[#39ff14] text-[#0d0d0f] font-bold text-lg md:text-xl rounded-full hover:shadow-[0_0_30px_rgba(57,255,20,0.8)] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Request Your Review
          </button>
        </div>
      </div>
    </section>
  );
}
